<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="500px"
    :persistent="persist"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-divider />
      <v-card-text>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
          outline
          class="v-alert_aligned-top"
        >
          <span
            v-if="htmlStatusText"
            v-html="htmlStatusText"
          />
          {{ statusText }}
          <div
            v-if="additionalText"
            class="mb-0 mt-2"
          >
            <component :is="additionalText" />
          </div>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import LoginError from '@/components/widgets/errorInstructions/LoginError';
import Error400 from '@/components/widgets/errorInstructions/Error400';
import Error404 from '@/components/widgets/errorInstructions/Error404';
import Error400Sheets from '@/components/widgets/errorInstructions/Error400Sheets';

export default {
    name: 'ErrorModal',
    components: {
        LoginError,
        Error400,
        Error404,
        Error400Sheets
    },
    data () {
        return {
            dialog: false,
            persist: true
        };
    },
    computed: {
        requestError () {
            return this.$store.getters.getErrors;
        },
        title () {
            if (this.requestError.status === 404) {
                return this.$t('errors.error_404.modal_title');
            }
            return this.$t('errors.title_modal');
        },
        statusText () {
            const langs = this.$t('errors');
            if (this.requestError.status === 0) {
                return this.$t('errors.network_error');
            }
            if (this.requestError.status in langs) {
                return langs[this.requestError.status] + ' (' + this.requestError.status + ')';
            }
            if (this.requestError.status === '403_login') {
                return langs.forbidden_login_1;
            }
            if (this.requestError?.status === '500_login') {
                return '';
            }

            return `${langs.error} ${this.requestError.statusText} (${this.requestError.status})`;
        },
        htmlStatusText () {
            if (this.requestError?.status === '500_login') {
                return this.$t('errors.server_login_error');
            }

            return '';
        },
        additionalText () {
            switch (this.requestError.status) {
            case '403_login':
                return 'LoginError';
            case '500_login':
                return 'ServerLoginError';
            case 400:
                return this.requestError.place === 'sheets' ? 'Error400Sheets' : 'Error400';
            case 404:
                return 'Error404';
            default:
                return '';
            }
        }
    },
    watch: {
        requestError (val) {
            this.dialog = val.visible;
            setTimeout(() => {
                this.persist = !this.dialog;
            }, 500);
        },
        dialog (val) {
            if (val === false) {
                this.$store.commit('clearErrors');
            }
        }
    },
    created () {
        this.dialog = this.requestError.visible;
        setTimeout(() => {
            this.persist = !this.dialog;
        }, 500);
    }
};
</script>

<style scoped></style>
